import BrokersAndAssetsWidget from "components/widgets/BrokersAndAssetsWidget";
import TryFreeWidget from 'components/widgets/TryFreeWidget';
import HeaderBoxWidget from 'components/widgets/HeaderBoxWidget';
import HeaderHomeBoxWidget from 'components/widgets/HeaderHomeBoxWidget';
import TextImageTextWidget from 'components/widgets/TextImageTextWidget';
import TextImageRightWidget from 'components/widgets/TextImageRightWidget';
import LearnPracticeTradeWidget from 'components/widgets/LearnPracticeTradeWidget';
import SocialTradingWidget from 'components/widgets/SocialTradingWidget';
import DocumentationQuestionsWidget from 'components/widgets/DocumentationQuestionsWidget';
import PlansWidget from 'components/widgets/PlansWidget';
import ComparePlansWidget from 'components/widgets/ComparePlansWidget';
import CartBoxWidget from 'components/widgets/CartBoxWidget';
import SimpleTextListWidget from 'components/widgets/SimpleTextListWidget';
import SimpleNoteWidget from 'components/widgets/SimpleNoteWidget';
import AboutBlockWidget from 'components/widgets/AboutBlockWidget';
import ContactBoxWidget from 'components/widgets/ContactBoxWidget';
import LearningListWidget from 'components/widgets/LearningListWidget';
import MostWantedWidget from 'components/widgets/LearningMostWantedWidget';
import LearningTrendingWidget from 'components/widgets/LearningTrendingWidget';
import MarketplaceItemWidget from 'components/widgets/MarketplaceItemWidget';
import TermsElements from 'components/widgets/TermsWidget';
import FaqItemWidget from 'components/widgets/FaqItemWidget';
import ChallengeWidget from 'components/widgets/ChallengeWidget';
import CartWidget from 'components/widgets/CartWidget';
import FinishWidget from 'components/widgets/FinishWidget';
import ChallengesItemWidget from 'components/widgets/ChallengesItemWidget';
import PrivacyPolicyListWidget from 'components/widgets/PrivacyPolicyListWidget';
import ContactUsInfoWidget from 'components/widgets/ContactUsInfoWidget';
import CookiesWidget from 'components/widgets/CookiesWidget';
import TwoColsTextWidget from 'components/widgets/TwoColsTextWidget';
import EditorWidget from "./EditorWidget";
import SpacerWidget from "./SpacerWidget";

const Widgets = {
    brokers_and_assets: BrokersAndAssetsWidget,
    learn_practice_trade: LearnPracticeTradeWidget,
    text_image_right: TextImageRightWidget,
    text_image_text: TextImageTextWidget,
    try_free: TryFreeWidget,
    header_box: HeaderBoxWidget,
    header_home_box: HeaderHomeBoxWidget,
    social_trading: SocialTradingWidget,
    documentations: DocumentationQuestionsWidget,
    plans: PlansWidget,
    compare_plans: ComparePlansWidget,
    cart_box: CartBoxWidget,
    simple_text_list: SimpleTextListWidget,
    simple_note: SimpleNoteWidget,
    about_block: AboutBlockWidget,
    address_box: ContactBoxWidget,
    learning_most_wanted: MostWantedWidget,
    learning_trending: LearningTrendingWidget,
    learning_list: LearningListWidget,
    marketplace: MarketplaceItemWidget,
    terms: TermsElements,
    challenge: ChallengeWidget,
    faq_item: FaqItemWidget,
    cart: CartWidget,
    finish: FinishWidget,
    challenges: ChallengesItemWidget,
    privacy_policy_list: PrivacyPolicyListWidget,
    contact_us_info: ContactUsInfoWidget,
    cookies: CookiesWidget,
    two_cols_text:TwoColsTextWidget,
    editor: EditorWidget,
    spacer: SpacerWidget,
}

export default Widgets;
